module.exports = __webpack_public_path__ + "img/41_27.5c46e58a.png";